import type { BookingDetails, RescheduleRequest, CancelRequest } from '../types';

const API_BASE = '/api';
const API_KEY = import.meta.env.VITE_API_KEY || '';

function getHeaders(): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json'
  };

  if (API_KEY) {
    headers['Authorization'] = `Bearer ${API_KEY}`;
  }

  return headers;
}

export async function getBooking(code: string): Promise<BookingDetails> {
  const response = await fetch(`${API_BASE}/get-booking?code=${encodeURIComponent(code)}`, {
    method: 'GET',
    headers: getHeaders()
  });

  if (!response.ok) {
    const errorData = await response.json().catch((e) => {
      console.error('Failed to parse error response:', e);
      return { error: `Failed to retrieve booking (${response.status})` };
    }) as { error?: string };
    throw new Error(errorData.error || 'Failed to retrieve booking');
  }

  return response.json();
}

export async function cancelBooking(request: CancelRequest): Promise<{ success: boolean; message: string }> {
  const response = await fetch(`${API_BASE}/cancel-booking`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(request)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Failed to cancel booking' })) as { error?: string };
    throw new Error(errorData.error || 'Failed to cancel booking');
  }

  return response.json();
}

export async function rescheduleBooking(request: RescheduleRequest): Promise<{
  success: boolean;
  bookingId?: string;
  confirmationNumber?: string;
  providerName: string;
  slot: { start: string; end: string };
  tz: string;
}> {
  const response = await fetch(`${API_BASE}/reschedule-booking`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(request)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Failed to reschedule booking' })) as { error?: string };
    throw new Error(errorData.error || 'Failed to reschedule booking');
  }

  return response.json();
}
